import React from 'react';
import styled from 'styled-components';

import HeroSection from 'components/HeroSection';
import Container from 'components/Container';
import Text from 'components/Text';

const Section = styled(HeroSection)`
  text-align: center;
  padding: 6rem 1.5rem;
`;

export default function Hero() {
  return (
    <Section variant="secondary">
      <Container size="sm">
        <Text as="h1" variant="hero">
          Privacy Policy
        </Text>
      </Container>
    </Section>
  );
}
